import { darken } from "@material-ui/core/styles/colorManipulator";
import { PrimaryButton } from "Shared/Buttons";
import CloseIcon from "src/components/icons/Close";
import GarageIcon from "src/components/icons/Garage";
import styled from "@emotion/styled";
import { ButtonProps } from "./FlyoutTypes";

export const GarageContainer = styled("div")`
    background: ${(props) => props.theme.palette.common.white};
`;

export const FlyoutButton = styled(PrimaryButton)`
    background: ${(props) => props.theme.palette.flyout.background};
    border-radius: 4px 4px 0 0;
    box-shadow: 0 -4px 0 0 ${(props) => darken(props.theme.palette.flyout.background, 0.2)};
    color: ${(props) => props.theme.palette.flyout.text};

    &:hover {
        background: ${(props) => darken(props.theme.palette.flyout.background, 0.2)};
    }

    ${(props) => props.theme.breakpoints.up("tablet")} {
        &:hover {
            background: ${(props) => props.theme.palette.flyout.background};

            button:hover,
            button:active {
                background: ${(props) => darken(props.theme.palette.flyout.background, 0.2)};
            }
        }
    }

    @media only screen and ${(props) =>
            `(min-width: ${props.theme.breakpoints.width("sm")}px) and (max-width: ${
                props.theme.breakpoints.width("md") - 1
            }px)`} {
        &:hover {
            background: ${(props) => props.theme.palette.flyout.background};

            button:hover,
            button:active {
                background: ${(props) => darken(props.theme.palette.flyout.background, 0.2)};
            }
        }
    }
`;

export const GarageHeaderButton = styled(FlyoutButton)`
    display: flex;
    justify-content: space-between;
`;

export const ButtonLabel = styled("span")`
    letter-spacing: normal;
    text-transform: none;
`;

export const StyledImage = styled("img")<{ hideTheLabel?: boolean }>`
    height: 28px;
    margin-right: ${(props) => (props.hideTheLabel ? "0" : "5px")};
    object-fit: contain;
    width: 33px;
`;

export const StyledGarageIcon = styled(GarageIcon)<ButtonProps>`
    color: ${(props) => props.theme.palette.flyout.text};
    height: 28px;
    margin-right: ${(props) => (props.hideTheLabel ? "0" : "5px")};
    width: 33px;
`;

export const StyledCloseIcon = styled(CloseIcon)`
    height: 20px;
    margin-right: 5px;
    width: 20px;

    g {
        stroke: ${(props) => props.theme.palette.primary.contrastText};
    }
`;
